export const EmptyEmpDlts ={
    emp_Code:'',
    emp_Name:'',
    team_lead:'',
    mobile:0,
    email:'',
    hangout:'',
    branch:''  

}